import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siteSelect", "useForTimesheets", "useForCheckins"]
  static values = { url: String, cancelUrl: String, errorMessage: String }

  async save(event) {
    event.preventDefault()

    const csrfToken = document.querySelector("[name='csrf-token']")?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "text/vnd.turbo-stream.html",
        },
        body: JSON.stringify({
          default_site_id: this.siteSelectTarget.value,
          use_for_timesheets: this.hasUseForTimesheetsTarget && this.useForTimesheetsTarget.checked,
          // Absent on fleet templates, where check-in usage does not exist.
          use_for_checkins: this.hasUseForCheckinsTarget && this.useForCheckinsTarget.checked,
        }),
      })

      if (!response.ok) throw new Error("Update failed")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error("Error updating default site:", error)
      alert(this.errorMessageValue || "Error saving. Please try again.")
    }
  }

  cancel(event) {
    event.preventDefault()

    const frame = document.getElementById("default_site_config")
    if (frame && this.cancelUrlValue) {
      frame.src = this.cancelUrlValue
      frame.reload()
    }
  }
}
